import { DomainData } from '../interface';

const initialDomainDataState: DomainData = {
    // all users
    users: [],

    // all user groups
    userGroups: [],

    // all user projects
    projects: [],

    // all user tasks
    tasks: [],

    // all projects tags
    tags: [],
};

export default initialDomainDataState;



// WEBPACK FOOTER //
// ./src/redux/initial-state/domainData.ts